import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { LeftPadPipe } from './left-pad.pipe';

@NgModule({
  declarations: [
    LeftPadPipe
  ],
  exports: [LeftPadPipe],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ]
})
export class PipeModule { }



// WEBPACK FOOTER //
// ./src/app/shared/pipes/pipe.module.ts